import { setCookie, getCookie, delCookie } from '@/static/js/zjs'

export default {
  get(bookId) {
    return getCookie(`kebenLock${bookId}`)
  },
  set(bookId) {
    return setCookie(`kebenLock${bookId}`, 1, 30)
  },
  del(bookId) {
    return delCookie(`kebenLock${bookId}`)
  }
}
